import { render, staticRenderFns } from "./customizeLink.vue?vue&type=template&id=ba778b20"
import script from "./customizeLink.vue?vue&type=script&lang=js"
export * from "./customizeLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports